import React from 'react'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as instructorActions from '../../_actions/roster.actions'
import * as leaveActions from '../../_actions/employeeLeave.actions'
import * as branchActions from '../../_actions/branch.actions'
import * as departmentActions from '../../_actions/department.actions'
import _ from 'lodash'
import BigCalendar from 'react-big-calendar'
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop'
// import 'react-big-calendar/lib/css/react-big-calendar.css'
// import 'react-big-calendar/lib/addons/dragAndDrop/styles.css'
import { Drawer, Select, Collapse, Button } from 'antd'
import LeaveDetails from '../etimeform/LeaveDetails'
// react-bootstrap modal
import Draggable from 'react-draggable'
// import Button from 'react-bootstrap/lib/Button';
// import Modal from 'react-bootstrap/Modal'
// import * as ModalDialog from 'react-bootstrap/ModalDialog'

import { Dialog } from 'primereact/dialog'
import { DndProvider } from 'react-dnd'
import TimeUtils from '../../utils/TimeUtils'
import Toolbar from './WorkToolbar'
import BrancheSelect from '../common/BrancheSelect'
import DepartmentSelect from '../common/DepartmentSelect'
import { toast } from 'react-toastify'
import { viewConstants } from '../../_constants/view.constants'
import rosterUtil from './util'

toast.configure()

const moment = require('moment')
const localizer = BigCalendar.momentLocalizer(moment)
const DragAndDropCalendar = withDragAndDrop(BigCalendar, DndProvider)

const WHOLE_DAY = 86400000

const NORMALWORKING_ACTION = 99

const ActionTypes = {
    NORMAL_WORKING: NORMALWORKING_ACTION,
    ANNUAL_LEAVE: 1,
    SICK_LEAVE: 2,
    ALTERNATIVE_LEAVE: 3,
    BEREAVEMENT_LEAVE: 4,
    LONGSERVICE_LEAVE: 5,
    SPECIAL_SERVICE_LEAVE: 6,
    DOMESTIC_LEAVE: 7,
    OTHER_PAID_LEAVE: 8,
    UNPAID_LEAVE: 9,
    OVERTIME_LIEU_LEAVE: 10,
    STUDY_LEAVE: 11,
    BIRTHDAY_LEAVE: 12,
    PARENTAL_LEAVE: 13,
}

// class DraggableModalDialog extends React.Component {
//     render() {
//         return (
//             <Draggable handle=".modal-title">
//                 <ModalDialog {...this.props} />
//             </Draggable>
//         )
//     }
// }

class WorkViewRoster extends React.PureComponent {
    state = {
        currentMonth: new Date(),
        selectedDate: new Date(),
        showModal: false,
        event: {},
        events: [],
        employees: [],
        show: false,
        activeTab: '1',
        mounted: false,
        currentDate: new Date(),
        modalActionType: '',
    }

    componentDidMount() {
        const { branches, departments } = this.props

        // Fetch branches and departments on mount
        if (branches.length === 0) {
            this.props.actions.branchActions.fetchBranchList()
        }

        if (departments.length === 0) {
            this.props.actions.departmentActions.fetchDepartmentList()
        }

        this.setState({ mounted: true })
    }

    displayEmployeeIds = displayEmployees => {
        const ids = displayEmployees.map(emp => {
            return emp.EmployeeAutoID
        })
        return ids
    }

    handleBranchChange = async branch => {
        // reset employee list
        await this.props.actions.rosterActions.selectEmployees([])

        // set branch filter
        await this.props.actions.rosterActions.selectBranches(branch)

        // update display employee
        let filterCond = {}
        if (!_.isEmpty(branch)) {
            filterCond.EmployeeBranch = branch
        }
        if (!_.isEmpty(this.props.selectedDepartments)) {
            filterCond.EmployeeDepartment = this.props.selectedDepartments
        }

        await this.props.actions.rosterActions.updateDisplayEmployee(filterCond)

        // fetch leave
        var cond = {}
        const options = {
            range: viewConstants.WEEK,
            time: this.props.currentWeekDate,
        }

        if (!_.isEmpty(this.props.displayEmployees)) {
            cond.employees = this.displayEmployeeIds(this.props.displayEmployees)
            this.props.actions.leaveActions.fetchEmployeeLeave(
                Object.assign({}, cond, options)
            )
        } else {
            // update display leave to empty
            this.props.actions.leaveActions.updateDisplayLeave({
                displayEvents: [],
            })
        }
    }
    handleDepartmentChange = async department => {
        // reset employee list
        await this.props.actions.rosterActions.selectEmployees([])

        // set department filter
        await this.props.actions.rosterActions.selectDepartments(department)

        // update display employee
        let filterCond = {}
        if (!_.isEmpty(department)) {
            filterCond.EmployeeDepartment = department
        }
        if (!_.isEmpty(this.props.selectedBranches)) {
            filterCond.EmployeeBranch = this.props.selectedBranches
        }

        await this.props.actions.rosterActions.updateDisplayEmployee(filterCond)

        // fetch leave
        var cond = {}
        const options = {
            range: viewConstants.WEEK,
            time: this.props.currentWeekDate,
        }

        if (!_.isEmpty(this.props.displayEmployees)) {
            cond.employees = this.displayEmployeeIds(this.props.displayEmployees)
            this.props.actions.leaveActions.fetchEmployeeLeave(
                Object.assign({}, cond, options)
            )
        } else {
            // update display leave to empty
            this.props.actions.leaveActions.updateDisplayLeave({
                displayEvents: [],
            })
        }
        // const { selectedBranch } = this.state

        // let filterCond = {}
        // if (department.value !== 'all') {
        //     filterCond.department = department.value
        // }
        // if (selectedBranch.value && selectedBranch.value !== 'all') {
        //     filterCond.branch = selectedBranch.value
        // }
        // filterCond.view = 'work'

        // this.props.actions.updateWorkAbsenceViewDisplayEvents(filterCond)
        // this.setState({
        //     selectedDepartment: department,
        // })
    }

    handleOpenModal = () => {
        this.setState({ showModal: true })
    }

    handleCloseModal = () => {
        this.setState({ showModal: false })
    }

    onFormHide = () => {
        this.setState({ modalActionType: '' })
    }

    // handleClose = () => {
    //     this.setState({ show: false })
    // }

    // handleShow = () => {
    //     this.setState({ show: true })
    // }

    castToUpdateModel = data => {
        const vm = {}

        vm.PayrollEmpRosterAutoID = data.id
        vm.PayrollEmpRosterEmployeeID = data.EmployeeID
        vm.PayrollEmpRosterStartDate = data.start
        vm.PayrollEmpRosterEndDate = data.end
        vm.PayrollEmpRosterActionNotes = data.Note || ''
        vm.PayrollEmpRosterBreakMinute = data.Break
        vm.PayrollEmpRosterDispTitle = data.Title

        return vm
    }

    moveEvent = ({ event, start, end, isAllDay: droppedOnAllDaySlot }) => {
        let allDay = event.allDay

        if (!event.allDay && droppedOnAllDaySlot) {
            allDay = true
        } else if (event.allDay && !droppedOnAllDaySlot) {
            allDay = false
        }

        const updatedEvent = { ...event, start, end, allDay }

        const payload = this.castToUpdateModel(updatedEvent)

        this.props.actions.updateWeekEvent(payload)
    }

    extendEvent = (event, start, end, sameStart) => {
        const newStartTime = TimeUtils.extractTime(event.start)
        const newEndTime = TimeUtils.extractTime(event.end)

        const minStart = moment.min([moment(start), moment(event.start)])
        const maxEnd = moment.max([moment(end), moment(event.end)])

        const adjustedMaxEnd = sameStart ? maxEnd.subtract(1, 'days') : maxEnd

        const eventStart = moment(TimeUtils.extractDate(minStart))

        let day = eventStart
        const cloneEvent = _.clone(event)

        while (day <= adjustedMaxEnd) {
            cloneEvent.start = moment(
                TimeUtils.combineDateNTime(day.clone(), newStartTime)
            )
            cloneEvent.end = moment(
                TimeUtils.combineDateNTime(day.clone(), newEndTime)
            )

            day.add(1, 'days')

            // exclude same event
            if (
                cloneEvent.start.isSame(event.start) &&
                cloneEvent.end.isSame(event.end)
            ) {
                console.log('same event')
            } else {
                delete cloneEvent.id
                console.log(JSON.stringify(cloneEvent))
                this.props.actions.addEvent(
                    cloneEvent,
                    this.props.selectedEmployee
                )
            }
        }
    }

    copyEvent = ({ event, start, end }) => {
        // const range = moment.range(start, end);

        // const rangeByDay = Array.from(range.by("day"));

        let data = {}
        data.id = event.id
        data.start = start
        data.end = end

        this.props.actions.copyInsertWeekEvents(data)
    }
    resizeEvent = ({ event, start, end }) => {
        const { displayWorkEvents } = this.props

        const duration = moment(end).diff(start) == WHOLE_DAY // 24 hours
        const sameStart = moment(start).isSame(event.start)
        const sameEnd = moment(end).isSame(event.end)
        const orgDuration = moment(event.end).diff(event.start) > WHOLE_DAY
        const sameDayEvent =
            moment(event.end).diff(event.start) < WHOLE_DAY &&
            moment(TimeUtils.extractDate(event.end)).isSame(
                TimeUtils.extractDate(event.start)
            )

        const nextEvents = _.find(displayWorkEvents, { id: event.id })

        // same day event
        if (sameDayEvent) {
            // repeatable event, expand to multiple days
            let period = 0
            if (sameStart) {
                period = moment(end).diff(event.start, 'days')
            } else if (sameEnd) {
                period = moment(event.end).diff(start, 'days')
            } else {
                period = moment(end).diff(start, 'days')
            }

            const multiple = period > 0

            if (multiple) {
                // repeat same event
                this.extendEvent(nextEvents, start, end, sameStart, sameEnd)
            } else {
                // within same day
                const newStartDate = TimeUtils.extractDate(start)
                const newStartTime = TimeUtils.extractTime(start)
                const newStart = TimeUtils.combineDateNTime(
                    newStartDate,
                    newStartTime
                )

                const newEndDate = TimeUtils.extractDate(end)
                const newEndTime = TimeUtils.extractTime(end)
                const newEnd = TimeUtils.combineDateNTime(
                    newEndDate,
                    newEndTime
                )

                nextEvents.start = moment(newStart)
                nextEvents.end = moment(newEnd)
                nextEvents.allDay = false
                this.props.actions.updateEvent(
                    nextEvents,
                    this.props.selectedEmployee
                )
            }
        }

        // whole period event, not repeatable
        if (!sameDayEvent) {
            // resize to the one day
            if (duration && (sameStart || sameEnd) && orgDuration) {
                const newEvtDate = sameStart
                    ? TimeUtils.extractDate(start)
                    : TimeUtils.extractDate(end)

                const sTime = TimeUtils.extractTime(event.start)
                const newStartDate = TimeUtils.combineDateNTime(
                    newEvtDate,
                    sTime
                )

                const eTime = TimeUtils.extractTime(event.end)
                const newEndDate = TimeUtils.combineDateNTime(newEvtDate, eTime)

                nextEvents.start = moment(newStartDate)
                nextEvents.end = moment(newEndDate)
                nextEvents.allDay = false
            } else {
                // extend to multiple days
                const overOneDay = moment(end).diff(event.start) > WHOLE_DAY

                if (overOneDay) {
                    const newStartDate = TimeUtils.extractDate(start)
                    const newStartTime = TimeUtils.extractTime(event.start)
                    const newStart = TimeUtils.combineDateNTime(
                        newStartDate,
                        newStartTime
                    )

                    // expand over one day event, same start, then -1 day
                    const oneDay = moment.duration(1, 'd')
                    const newEndDate = sameStart
                        ? TimeUtils.extractDate(moment(end).subtract(oneDay))
                        : TimeUtils.extractDate(end)
                    const newEndTime = TimeUtils.extractTime(event.end)
                    const newEnd = TimeUtils.combineDateNTime(
                        newEndDate,
                        newEndTime
                    )

                    nextEvents.start = moment(newStart)
                    nextEvents.end = moment(newEnd)
                    nextEvents.allDay = false
                } else {
                    // within same day
                    const newStartDate = TimeUtils.extractDate(start)
                    const newStartTime = TimeUtils.extractTime(start)
                    const newStart = TimeUtils.combineDateNTime(
                        newStartDate,
                        newStartTime
                    )

                    const newEndDate = TimeUtils.extractDate(end)
                    const newEndTime = TimeUtils.extractTime(end)
                    const newEnd = TimeUtils.combineDateNTime(
                        newEndDate,
                        newEndTime
                    )

                    nextEvents.start = moment(newStart)
                    nextEvents.end = moment(newEnd)
                    nextEvents.allDay = false
                }
            }
            this.props.actions.updateEvent(
                nextEvents,
                this.props.selectedEmployee
            )
        }
    }

    disableSelect = e => {}
    newEvent = event => {
        let eTimeRequest = {
            id: '',
            title: '',
            actionType: {
                label: 'Normal working',
                value: NORMALWORKING_ACTION,
            },
            allDay: event.slots.length == 1,
            dateFrom: event.start,
            dateTo: event.slots.length > 1 ? event.end : undefined,
            draggable: true,
            status: 'edit',
            startTime: '09:00',
            endTime: '17:30',
            duration: '',
            break: event.break || '0',
            note: '',
            existing: false,
        }

        this.setState({ event: eTimeRequest })
        this.setState({ modalActionType: 'create' })
        // const { selectedEmployee } = this.props;
        // this.filterEvents(selectedEmployee)
    }

    customEventPropGetter = event => {
        const eventType = event.ActionType
        if (eventType) {
            switch (eventType) {
                case ActionTypes.NORMAL_WORKING:
                    return {
                        className: 'boxGreen',
                    }
                case ActionTypes.ANNUAL_LEAVE:
                    return {
                        className: 'boxTomato',
                    }
                case ActionTypes.SICK_LEAVE:
                    return {
                        className: 'boxOrange',
                    }
                case ActionTypes.ALTERNATIVE_LEAVE:
                    return {
                        className: 'boxDodgerBlue',
                    }
                case ActionTypes.BEREAVEMENT_LEAVE:
                    return {
                        className: 'boxMediumSeaGreen',
                    }
                case ActionTypes.OVERTIME_LIEU_LEAVE:
                    return {
                        className: 'boxGray',
                    }
                case ActionTypes.OTHER_PAID_LEAVE:
                    return {
                        className: 'boxViolet',
                    }
                case ActionTypes.PARENTAL_LEAVE:
                    return {
                        className: 'boxSlateBlue',
                    }
                case ActionTypes.UNPAID_LEAVE:
                    return {
                        className: 'boxLightGray',
                    }
                case ActionTypes.LONGSERVICE_LEAVE:
                    return {
                        className: 'boxLight-1',
                    }
                case ActionTypes.SPECIAL_SERVICE_LEAVE:
                    return {
                        className: 'boxLight-2',
                    }
                case ActionTypes.DOMESTIC_LEAVE:
                    return {
                        className: 'boxLight-3',
                    }
                case ActionTypes.STUDY_LEAVE:
                    return {
                        className: 'boxLight-4',
                    }
                case ActionTypes.BIRTHDAY_LEAVE:
                    return {
                        className: 'boxLight-5',
                    }
                default:
                    return {
                        className: 'boxDodgerBlue',
                    }
            }
        } else return {}
    }

    renderEvetDetail = event => {
        let eTimeRequest = {
            id: event.id,
            title: event.Title || event.title,
            actionType: event.ActionType,
            allDay: event.allDay,
            dateFrom: event.start,
            dateTo: event.end,
            startTime: TimeUtils.extractTime(event.start),
            endTime: TimeUtils.extractTime(event.end),
            duration: event.ActionHours || '',
            break: event.Break || 0,
            Note: event.Note || '',
            existing: true,
            approved: event.approved,
            employeeID: event.EmployeeID,
            hours: event.hours || 0,
            source: event.source,
        }

        this.setState({ event: eTimeRequest })
        this.setState({ modalActionType: 'update' })
    }

    removeEvent = event => {
        this.props.actions
            .removeEventById(this.state.event.id)
            .then(res =>
                _.head(document.getElementsByClassName('close')).click()
            )
            .catch(error => {
                console.log(`error=${error}`)
            })
    }

    customColorEventPropGetter = event => {
        // Get base color based on leave type
        let baseColor = '#0a75ad' // default color

        if (event.Status) {
            baseColor = '#C8C6C6'
        } else {
            switch (event.PayrollEmpLeaveTypeID) {
                case 1:
                    baseColor = '#065535'
                    break
                case 2:
                    baseColor = '#000000'
                    break
                case 3:
                    baseColor = '#133337'
                    break
                case 4:
                    baseColor = '#d1477a'
                    break
                case 5:
                    baseColor = '#b8860b'
                    break
                case 6:
                    baseColor = '#e6940a'
                    break
                case 7:
                    baseColor = '#0000ff'
                    break
                case 8:
                    baseColor = '#cd5c5c'
                    break
                case 9:
                    baseColor = '#7ba428'
                    break
                case 10:
                    baseColor = '#4682b4'
                    break
                case 11:
                    baseColor = '#666666'
                    break
                case 12:
                    baseColor = '#7ba428'
                    break
                case 13:
                    baseColor = '#cd5c5c'
                    break
                case 14:
                    baseColor = '#708090'
                    break
                case 19:
                    baseColor = '#800080'
                    break
                case 20:
                    baseColor = '#800000'
                    break
                default:
                    baseColor = '#0a75ad'
                    break
            }
        }

        // Apply approval status styling
        if (event.approved === false || event.approved === 0) {
            // Non-approved events: striped pattern or dashed border
            return {
                style: {
                    backgroundColor: baseColor,
                    opacity: 0.6,
                    border: '2px dashed #ff4d4f',
                    borderRadius: '4px',
                    backgroundImage: `repeating-linear-gradient(
                        45deg,
                        transparent,
                        transparent 2px,
                        rgba(255,255,255,0.3) 2px,
                        rgba(255,255,255,0.3) 4px
                    )`,
                },
            }
        } else if (event.approved === true || event.approved === 1) {
            // Approved events: solid color with green checkmark indicator
            return {
                style: {
                    backgroundColor: baseColor,
                    border: '2px solid #52c41a',
                    borderRadius: '4px',
                    position: 'relative',
                },
            }
        } else {
            // Pending or unknown status: default styling
            return {
                style: {
                    backgroundColor: baseColor,
                    border: '2px solid #faad14',
                    borderRadius: '4px',
                    opacity: 0.8,
                },
            }
        }
    }
    // customColorEventPropGetter = event => {
    //     // Get base color based on leave type
    //     let baseColor = '#0a75ad' // default color
        
    //     if (event.Status) {
    //         baseColor = '#C8C6C6'
    //     } else {
    //         switch (event.PayrollEmpLeaveTypeID) {
    //             case 1:
    //                 return {
    //                     style: {
    //                         backgroundColor: '#065535',
    //                     },
    //                 }
    //             case 2:
    //                 return {
    //                     style: {
    //                         backgroundColor: '#000000',
    //                     },
    //                 }
    //             case 3:
    //                 return {
    //                     style: {
    //                         backgroundColor: '#133337',
    //                     },
    //                 }
    //             case 4:
    //                 return {
    //                     style: {
    //                         backgroundColor: '#d1477a',
    //                     },
    //                 }
    //             case 5:
    //                 return {
    //                     style: {
    //                         backgroundColor: '#b8860b',
    //                     },
    //                 }
    //             case 6:
    //                 return {
    //                     style: {
    //                         backgroundColor: '#e6940a',
    //                     },
    //                 }
    //             case 7:
    //                 return {
    //                     style: {
    //                         backgroundColor: '#0000ff',
    //                     },
    //                 }
    //             case 8:
    //                 return {
    //                     style: {
    //                         backgroundColor: '#cd5c5c',
    //                     },
    //                 }
    //             case 9:
    //                 return {
    //                     style: {
    //                         backgroundColor: '#7ba428',
    //                     },
    //                 }
    //             case 10:
    //                 return {
    //                     style: {
    //                         backgroundColor: '#4682b4',
    //                     },
    //                 }
    //             case 11:
    //                 return {
    //                     style: {
    //                         backgroundColor: '#666666',
    //                     },
    //                 }
    //             case 12:
    //                 return {
    //                     style: {
    //                         backgroundColor: '#7ba428',
    //                     },
    //                 }
    //             case 13:
    //                 return {
    //                     style: {
    //                         backgroundColor: '#cd5c5c',
    //                     },
    //                 }
    //             case 14:
    //                 return {
    //                     style: {
    //                         backgroundColor: '#708090',
    //                     },
    //                 }
    //             case 19:
    //                 return {
    //                     style: {
    //                         backgroundColor: '#800080',
    //                     },
    //                 }
    //             case 20:
    //                 baseColor = '#800000'
    //                 break
    //             default:
    //                 baseColor = '#0a75ad'
    //                 break
    //         }
    //     }

    //     // Apply approval status styling
    //     if (event.approved === false || event.approved === 0) {
    //         // Non-approved events: striped pattern with dashed border
    //         return {
    //             style: {
    //                 backgroundColor: baseColor,
    //                 opacity: 0.6,
    //                 border: '2px dashed #ff4d4f',
    //                 borderRadius: '4px',
    //                 backgroundImage: `repeating-linear-gradient(
    //                     45deg,
    //                     transparent,
    //                     transparent 2px,
    //                     rgba(255,255,255,0.3) 2px,
    //                     rgba(255,255,255,0.3) 4px
    //                 )`,
    //             },
    //         }
    //     } else if (event.approved === true || event.approved === 1) {
    //         // Approved events: solid color with green border
    //         return {
    //             style: {
    //                 backgroundColor: baseColor,
    //                 border: '2px solid #52c41a',
    //                 borderRadius: '4px',
    //             },
    //         }
    //     } else {
    //         // Pending or unknown status: default styling with warning border
    //         return {
    //             style: {
    //                 backgroundColor: baseColor,
    //                 border: '2px solid #faad14',
    //                 borderRadius: '4px',
    //             },
    //         }
    //     }
    // }

    filterWorkAbsenceEvents = (events, viewType) => {
        if (viewType === 'work') {
            const filteredEvents = _.filter(events, function(evt) {
                return evt.ActionType === NORMALWORKING_ACTION
            })

            _.sortBy(filteredEvents, ['start'])
            return filteredEvents
        } else {
            const filteredEvents = _.filter(events, function(evt) {
                return evt.ActionType !== NORMALWORKING_ACTION
            })
            _.sortBy(filteredEvents, ['start'])
            return filteredEvents
        }
    }

    // handle employee selection
    handleEmployeeChange = value => {
        this.props.actions.rosterActions.selectEmployees(value)

        var cond = {}
        const options = {
            range: viewConstants.WEEK,
            time: this.props.currentWeekDate,
        }

        if (!_.isEmpty(value)) {
            cond.employees = value
        }

        this.props.actions.leaveActions.fetchEmployeeLeave(
            Object.assign({}, cond, options)
        )
    }

    displayEmployees = employeeFilter => {
        const empList = employeeFilter
            ? employeeFilter
            : this.props.employeeList
        const empOption = empList.map(emp => {
            let o = {}
            o.label = emp.EmployeeName
            o.value = emp.key
            return o
        })

        return empOption
    }

    handleReset = async () => {
        // Reset Redux state
        this.props.actions.rosterActions.selectEmployees([])
        this.props.actions.rosterActions.selectBranches([])
        this.props.actions.rosterActions.selectDepartments([])

        // Reset filters in Redux store
        let filterCond = {}
        filterCond.EmployeeDepartment = []
        filterCond.EmployeeBranch = []

        await this.props.actions.rosterActions.updateDisplayEmployee(filterCond)

        // Fetch all employee leave data
        var cond = {}
        const options = {
            range: viewConstants.WEEK,
            time: this.props.currentWeekDate,
        }

        this.props.actions.leaveActions.fetchEmployeeLeave(
            Object.assign({}, cond, options)
        )
    }

    // handleReset = async () => {
    //     this.setState({ selectedEmployees: [] })
    //     this.setState({ selectedBranches: [] })
    //     this.setState({ selectedDepartments: [] })

    //     // update display employee and roster
    //     let filterCond = {}
    //     filterCond.EmployeeDepartment = []
    //     filterCond.EmployeeBranch = []

    //     // dispatch sync action
    //     await this.props.actions.rosterActions.updateDisplayEmployee(filterCond)
        

    //     let cond = {}
    //     const options = {
    //         range: viewConstants.WEEK,
    //         time: this.props.currentWeekDate,
    //     }

    //     this.props.actions.leaveActions.fetchEmployeeLeave(
    //         Object.assign({}, cond, options)
    //     )
    // }

    render() {
        let allViews = Object.keys(BigCalendar.Views).map(
            k => BigCalendar.Views[k]
        )
        const {
            displayEmployees,
            selectedEmployees,
            selectedBranches,
            selectedDepartments,
        } = this.props

        let components = {
            toolbar: Toolbar,
        }

        return (
            <div className="">
                <div className="row">
                    <div className="col-md-12"></div>
                    <div className="panel">
                        <div className="panel-heading">
                            <h3 className="panel-title"></h3>
                        </div>
                        <div className="panel-body">
                            <div className="container-fluid">
                                <div className="row mb-2">
                                    <div className="col-sm-3">
                                        <Select
                                            mode="multiple"
                                            allowClear
                                            style={{
                                                width: '100%',
                                            }}
                                            placeholder="Select employees"
                                            defaultValue={[]}
                                            onChange={this.handleEmployeeChange}
                                            options={this.displayEmployees()}
                                            value={selectedEmployees}
                                            maxTagCount="responsive"
                                            filterOption={(input, option) =>
                                                (option?.label ?? '')
                                                    .toLowerCase()
                                                    .includes(
                                                        input.toLowerCase()
                                                    )
                                            }
                                        />
                                    </div>
                                    {!_.isEmpty(this.props.branches) && (
                                        <div className="col-sm-3">
                                            <div className="rosterToolBar">
                                                <BrancheSelect
                                                    selectedBranches={
                                                        selectedBranches
                                                    }
                                                    handleChange={this.handleBranchChange.bind(
                                                        this
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    {!_.isEmpty(this.props.departments) && (
                                        <div className="col-sm-3">
                                            <div className="rosterToolBar">
                                                <DepartmentSelect
                                                    selectedDepartments={
                                                        selectedDepartments
                                                    }
                                                    handleChange={this.handleDepartmentChange.bind(
                                                        this
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    <div className="col-sm-3">
                                        <Button
                                            htmlType="button"
                                            onClick={this.handleReset}
                                        >
                                            Reset
                                        </Button>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="panel">
                                            <div className="panel-body">
                                                {/* <div>
                                                    <p>
                                                        Total Labour Cost: $5000
                                                    </p>
                                                </div> */}
                                                <div className="calendar">
                                                    <div className="example">
                                                        <DragAndDropCalendar
                                                            popup
                                                            selectable
                                                            localizer={
                                                                localizer
                                                            }
                                                            // events={this.props.displayWorkEvents}
                                                            events={_.map(
                                                                this.props
                                                                    .displayWorkEvents,
                                                                (obj, key) => {
                                                                    return obj
                                                                }
                                                            )}
                                                            // onEventDrop={
                                                            //     this.moveEvent
                                                            // }
                                                            resizable
                                                            // onEventResize={
                                                            //     this.copyEvent
                                                            // }
                                                            onSelectEvent={
                                                                this
                                                                    .renderEvetDetail
                                                            }
                                                            // onSelectSlot={
                                                            //     this.newEvent
                                                            // }
                                                            views={['roster']}
                                                            defaultView={
                                                                BigCalendar
                                                                    .Views
                                                                    .ROSTER
                                                            }
                                                            defaultDate={
                                                                new Date()
                                                            }
                                                            eventPropGetter={
                                                                this.customColorEventPropGetter
                                                            }
                                                            titleAccessor="Title"
                                                            startAccessor="start"
                                                            endAccessor="end"
                                                            showMultiDayTimes={
                                                                true
                                                            }
                                                            draggableAccessor="draggable"
                                                            culture="en-NZ"
                                                            tooltipAccessor="Title"
                                                            step={1440}
                                                            timeslots={1}
                                                            classNameCustom="rbc-roster"
                                                            components={
                                                                components
                                                            }
                                                            employees={
                                                                this.props
                                                                    .employees
                                                            }
                                                            showHours={false}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12" />
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <Dialog
                                            header="Create roster"
                                            visible={
                                                this.state.modalActionType ===
                                                'create'
                                            }
                                            // footer={renderFooter('displayBasic')}
                                            onHide={this.onFormHide}
                                            maximized={false}
                                            maximizable={false}
                                            resizable={true}
                                            breakpoints={{
                                                '960px': '75vw',
                                                '640px': '100vw',
                                            }}
                                            style={{ width: '50vw' }}
                                        >
                                            <LeaveDetails
                                                event={this.state.event}
                                                renderContent="roster"
                                                selectedEmployees={
                                                    selectedEmployees
                                                }
                                                actionTypes={
                                                    this.props.readOnly
                                                        ? _.slice(
                                                              this.props
                                                                  .actionTypes,
                                                              1
                                                          )
                                                        : this.props.actionTypes
                                                }
                                                showEmployee={true}
                                                disableEmployeeSelection={false}
                                                onHide={this.onFormHide}
                                                readOnly={true}
                                            />
                                        </Dialog>

                                        <Dialog
                                            header="leave"
                                            visible={
                                                this.state.modalActionType ===
                                                'update'
                                            }
                                            // footer={renderFooter('displayBasic')}
                                            onHide={this.onFormHide}
                                            maximized={false}
                                            maximizable={false}
                                            resizable={true}
                                            breakpoints={{
                                                '960px': '75vw',
                                                '640px': '100vw',
                                            }}
                                            style={{ width: '50vw' }}
                                        >
                                            <LeaveDetails
                                                event={this.state.event}
                                                renderContent="leave"
                                                selectedEmployees={
                                                    selectedEmployees
                                                }
                                                actionTypes={
                                                    this.props.readOnly
                                                        ? _.slice(
                                                              this.props
                                                                  .actionTypes,
                                                              1
                                                          )
                                                        : this.props.actionTypes
                                                }
                                                showEmployee={true}
                                                disableEmployeeSelection={false}
                                                onHide={this.onFormHide}
                                                weekView={true}
                                                readOnly={true}
                                            />
                                        </Dialog>
                                        {/* <Modal
                                            dialogComponentClass={
                                                DraggableModalDialog
                                            }
                                            dialogClassName="mod-w450"
                                            show={this.state.show}
                                            onHide={this.handleClose}
                                        >
                                            <div>
                                                <div>
                                                    <Modal.Header closeButton>
                                                        <Modal.Title>
                                                            Request
                                                            Absence/Attendance
                                                        </Modal.Title>
                                                    </Modal.Header>
                                                    <ETimeForm
                                                        event={this.state.event}
                                                        actions={
                                                            this.props.actions
                                                        }
                                                        employeeList={
                                                            this.props.employees
                                                        }
                                                        renderContent="workview"
                                                        actionTypes={
                                                            this.props.readOnly
                                                                ? _.slice(
                                                                      this.props
                                                                          .actionTypes,
                                                                      1
                                                                  )
                                                                : this.props
                                                                      .actionTypes
                                                        }
                                                        showEmployee={true}
                                                    />
                                                </div>
                                            </div>
                                        </Modal> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        events: state.roster.events,
        currentWeekDate: state.roster.currentWeekDate,
        displayWorkEvents: state.employeeLeave.displayLeaves,
        employeeList: state.roster.employeeList,
        displayEmployees: state.roster.displayEmployees,
        selectedEmployee: state.roster.selectedEmployee,
        selectedEmployees: state.roster.selectedEmployees,
        selectedBranches: state.roster.selectedBranches,
        selectedDepartments: state.roster.selectedDepartments,
        branches: state.BranchReducer.branchList,
        departments: state.DepartmentReducer.departmentList,
        actionTypes: state.ActionTypesReducer.actionTypes,
        colors: state.colors.colors,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            rosterActions: bindActionCreators(instructorActions, dispatch),
            leaveActions: bindActionCreators(leaveActions, dispatch),
            branchActions: bindActionCreators(branchActions, dispatch),
            departmentActions: bindActionCreators(departmentActions, dispatch),
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkViewRoster)
